export enum DealStatus {
    NEW = 'new',
    CANCELED = 'canceled',
    TRANSFER_WAITING = 'transfer_waiting',
    TRANSFER_CONFIRMED = 'transfer_confirmed',
    COMPLETED = 'completed',
    DISPUTE = 'dispute'
}